import { render, staticRenderFns } from "./ExhibitionBody.vue?vue&type=template&id=2ccdb728&scoped=true&"
import script from "./ExhibitionBody.vue?vue&type=script&lang=js&"
export * from "./ExhibitionBody.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionBody.vue?vue&type=style&index=0&id=2ccdb728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccdb728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccdb728')) {
      api.createRecord('2ccdb728', component.options)
    } else {
      api.reload('2ccdb728', component.options)
    }
    module.hot.accept("./ExhibitionBody.vue?vue&type=template&id=2ccdb728&scoped=true&", function () {
      api.rerender('2ccdb728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Exhibition/ExhibitionBody.vue"
export default component.exports